import { apiClient } from './client';
import {AxiosResponse} from 'axios';
import {Trip} from "@/models/Trip";
import {Offer} from "@/models/Offer";
import {SavedOffer} from "@/models/SavedOffer";
import {CrewMember} from "@/models/CrewMember";

const baseUrl = "/trip"

export const getTrip = (uuid: string): Promise<AxiosResponse<Trip>> => {
    return apiClient.get(`${baseUrl}/${uuid}`);
};

export const getTrips=():Promise<AxiosResponse<Trip[]>>  => {
    return apiClient.get(`${baseUrl}`);
};

export const createTrip = (tripData: Partial<Trip>): Promise<AxiosResponse<Trip>> => {
    return apiClient.post<Trip>(`${baseUrl}`, tripData);
};

export const updateTrip = (uuid: string, tripData: Partial<Trip>): Promise<AxiosResponse> => {
    return apiClient.patch(`${baseUrl}/${uuid}`, tripData);
};

export const deleteTrip = (uuid: string): Promise<AxiosResponse<{ message: string }>> => {
    return apiClient.delete(`${baseUrl}/${uuid}`);
};


export const addOffers = (slug:string, offer: Offer[]): Promise<AxiosResponse<SavedOffer[]>> => {
    return apiClient.post(`${baseUrl}/${slug}/offers`, offer);
};

export const createInquiry = (id:number, offer: Offer): Promise<AxiosResponse<SavedOffer[]>> => {
    return apiClient.post(`/reservation/inquiry`, offer);
};

export const getSavedOffers = (uuid: string): Promise<AxiosResponse<SavedOffer[]>> => {
    return apiClient.get(`${baseUrl}/${uuid}/saved-offers`);
};


export const getTripCrew = (uuid: string): Promise<AxiosResponse<CrewMember[]>> => {
    return apiClient.get(`${baseUrl}/${uuid}/crew`);
};
export const addTripCrew = (uuid: string, crewData: Partial<CrewMember>): Promise<AxiosResponse<CrewMember>> => {
    return apiClient.post(`${baseUrl}/${uuid}/crew`, crewData);
};

export const updateTripCrew = (tripUuid: string, crewUuid: string, crewData: Partial<CrewMember>): Promise<AxiosResponse<CrewMember>> => {
    return apiClient.patch(`${baseUrl}/${tripUuid}/crew/${crewUuid}`, crewData);
};

export const deleteTripCrew = (tripUuid: string, crewUuid: string): Promise<AxiosResponse<{ message: string }>> => {
    return apiClient.delete(`${baseUrl}/${tripUuid}/crew/${crewUuid}`);
};
